import { createElement, useContext } from 'react';
import { FormItem } from '@formily/antd';
import { createSchemaField, useForm } from '@formily/react';
import { syncUI, useVoidSchema } from '../';
import { Alert } from 'antd';
const getVoidSchemaComponent = (component, defaultProps, transformSchema) => {
    const SchemaField = createSchemaField({
        components: {
            ...component,
            FormItem,
        },
    });
    const VoidSchemaComponent = (props) => {
        const form = useForm();
        let schema = useVoidSchema(props, defaultProps);
        const appContext = useContext(window.__appContext);
        if (!form) {
            return createElement(Alert, { message: "formily component can only be used in formily form", type: "error" });
        }
        if (transformSchema) {
            schema = transformSchema(schema);
        }
        return createElement(SchemaField, { schema: schema, scope: { $this: appContext?.pageContext } });
    };
    return syncUI(VoidSchemaComponent);
};
export default getVoidSchemaComponent;
